import {SchemaState} from "./SchemaContext";

export enum SchemaContextActionType {
  LOADING,
  GET_SCHEMA,
  GET_GQL_SCHEMA,
  GET_STATISTICS,
  ADD_ERROR,
  UPDATE_DATA_VALIDATION_RUNNING
}

type Action = {
  type: SchemaContextActionType;
  payload: any
}

export default (state: SchemaState, action: Action) => {
  switch (action.type) {
    case SchemaContextActionType.LOADING:
      return {
        ...state,
        loading: action.payload.loading
      };
    case SchemaContextActionType.GET_SCHEMA:
      return {
        ...state,
        schema: action.payload.schema,
        schemaId: action.payload.schemaId,
        isBound: action.payload.isBound,
        loading: action.payload.loading,
        permissions: action.payload.permissions,
        defaultAnalyzer: action.payload.defaultAnalyzer,
        searchableProperties: action.payload.searchableProperties
      };
    case SchemaContextActionType.GET_STATISTICS:
      return {
        ...state,
        stats: action.payload.stats,
        loading: action.payload.loading
      };
    case SchemaContextActionType.GET_GQL_SCHEMA:
      return {
        ...state,
        graphQlSchema: action.payload.graphQlSchema,
        loading: action.payload.loading
      };
    case SchemaContextActionType.UPDATE_DATA_VALIDATION_RUNNING:
      return {
        ...state,
        isDataValidationRunning: action.payload.isDataValidationRunning,
        dataValidationReport: action.payload.dataValidationReport
      };
    case SchemaContextActionType.ADD_ERROR:
      return {
        ...state,
        error: action.payload.error,
        loading: action.payload.loading
      };
    default:
      return state;
  }
}
